import { render } from "./ExamBackupImagesOffcanvas.vue?vue&type=template&id=7590749e&scoped=true"
import script from "./ExamBackupImagesOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamBackupImagesOffcanvas.vue?vue&type=script&lang=js"

import "./ExamBackupImagesOffcanvas.vue?vue&type=style&index=0&id=7590749e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7590749e"]])

export default __exports__